import { DayType } from './DayType'

export const DAY_TYPE_BORDER_COLORS: Record<number, string> = {
  [DayType.NONE]: '#D9D9D9',

  [DayType.P]: '#74EAAB',
  [DayType.Ps]: '#74EAAB',

  [DayType.D]: '#A8E2C3',
  [DayType.Prz]: '#A8E2C3',

  [DayType.Nn]: '#EBA1C7',
  [DayType.Np]: '#EBA1C7',
  [DayType.Nu]: '#EBA1C7',

  [DayType.W]: '#74D4EA',
  [DayType.Wo]: '#74D4EA',

  [DayType.Xw]: '#96E3F5',
  [DayType.Xb]: '#96E3F5',
  [DayType.Xd]: '#96E3F5',
  [DayType.Wn]: '#96E3F5',
  [DayType.Wx]: '#96E3F5',
  [DayType.Ws]: '#96E3F5',

  [DayType.Ui]: '#F5BD96',
  [DayType.Un]: '#F5BD96',
  [DayType.Ur]: '#F5BD96',
  [DayType.Ux]: '#F5BD96',
  [DayType.Us]: '#F5BD96',
  [DayType.Um]: '#F5BD96',
  [DayType.Uf]: '#F5BD96',
  [DayType.Bp]: '#F5BD96',
  [DayType.D1]: '#F5BD96',
  [DayType.D2]: '#F5BD96',
  [DayType.U2]: '#F5BD96',
  [DayType.C]: '#F5BD96',
  [DayType.M]: '#F5BD96',
  [DayType.Uoj]: '#F5BD96',
  [DayType.Z]: '#F5BD96',
  [DayType.Zb]: '#F5BD96',
  [DayType.Zs]: '#F5BD96',
  [DayType.Zw]: '#F5BD96',
  [DayType.Zn]: '#F5BD96',
  [DayType.Od]: '#F5BD96',
  [DayType.Os]: '#F5BD96',
  [DayType.Or]: '#F5BD96',
  [DayType.Oo]: '#F5BD96',
  [DayType.Cn]: '#F5BD96',
  [DayType.Cb]: '#F5BD96',
  [DayType.Rb]: '#F5BD96',
  [DayType.Rc]: '#F5BD96',
  [DayType.Rw]: '#F5BD96',
  [DayType.Bw]: '#F5BD96',
  [DayType.WoC]: '#F5BD96',
  [DayType.WoCn]: '#F5BD96',
  [DayType.WoCb]: '#F5BD96',
  [DayType.WoZ]: '#F5BD96',
  [DayType.WoZb]: '#F5BD96',
  [DayType.WoZs]: '#F5BD96',
  [DayType.WoZw]: '#F5BD96',
  [DayType.WoZn]: '#F5BD96',
  [DayType.WoOd]: '#F5BD96',
  [DayType.WoOr]: '#F5BD96',
  [DayType.WoRc]: '#F5BD96',
  [DayType.WoRw]: '#F5BD96',
  [DayType.WoRb]: '#F5BD96',
  [DayType.WoOo]: '#F5BD96',
  [DayType.WoM]: '#F5BD96',
  [DayType.WoUoj]: '#F5BD96',
  [DayType.WoOs]: '#F5BD96',

  [DayType.U]: '#E2BB8F',
  [DayType.Uz]: '#E2BB8F',
  [DayType.Uo]: '#E2BB8F',

  [DayType.Sw]: '#D9D9D9',
  [DayType.Pw]: '#D9D9D9',
  [DayType.NoContract]: '#D9D9D9',
}

export const DAY_TYPE_STRIPE_COLORS: Record<number, string> = {
  [DayType.NONE]: '#D9D9D9',

  [DayType.P]: '#15DD72',
  [DayType.D]: '#15DD72',
  [DayType.Prz]: '#15DD72',

  [DayType.Nn]: '#DD157C',
  [DayType.Np]: '#DD157C',
  [DayType.Nu]: '#DD157C',

  [DayType.W]: '#15B8DD',
  [DayType.Wo]: '#15B8DD',
  [DayType.Xw]: '#15B8DD',
  [DayType.Xb]: '#15B8DD',
  [DayType.Xd]: '#15B8DD',
  [DayType.Wn]: '#15B8DD',
  [DayType.Wx]: '#15B8DD',
  [DayType.Ws]: '#15B8DD',

  [DayType.Ui]: '#FD8637',
  [DayType.Un]: '#FD8637',
  [DayType.Ur]: '#FD8637',
  [DayType.Ux]: '#FD8637',
  [DayType.Us]: '#FD8637',
  [DayType.Um]: '#FD8637',
  [DayType.Uf]: '#FD8637',
  [DayType.Bp]: '#FD8637',
  [DayType.D1]: '#FD8637',
  [DayType.D2]: '#FD8637',
  [DayType.U2]: '#FD8637',
  [DayType.C]: '#FD8637',
  [DayType.M]: '#FD8637',
  [DayType.Uoj]: '#FD8637',
  [DayType.Z]: '#FD8637',
  [DayType.Zb]: '#FD8637',
  [DayType.Zs]: '#FD8637',
  [DayType.Zw]: '#FD8637',
  [DayType.Zn]: '#FD8637',
  [DayType.Od]: '#FD8637',
  [DayType.Os]: '#FD8637',
  [DayType.Or]: '#FD8637',
  [DayType.Oo]: '#FD8637',
  [DayType.Cn]: '#FD8637',
  [DayType.Cb]: '#FD8637',
  [DayType.Rb]: '#FD8637',
  [DayType.Rc]: '#FD8637',
  [DayType.Rw]: '#FD8637',
  [DayType.Bw]: '#FD8637',
  [DayType.WoC]: '#FD8637',
  [DayType.WoCn]: '#FD8637',
  [DayType.WoCb]: '#FD8637',
  [DayType.WoZ]: '#FD8637',
  [DayType.WoZb]: '#FD8637',
  [DayType.WoZs]: '#FD8637',
  [DayType.WoZw]: '#FD8637',
  [DayType.WoZn]: '#FD8637',
  [DayType.WoOd]: '#FD8637',
  [DayType.WoOr]: '#FD8637',
  [DayType.WoRc]: '#FD8637',
  [DayType.WoRw]: '#FD8637',
  [DayType.WoRb]: '#FD8637',
  [DayType.WoOo]: '#FD8637',
  [DayType.WoM]: '#FD8637',
  [DayType.WoUoj]: '#FD8637',
  [DayType.WoOs]: '#FD8637',

  [DayType.U]: '#FDA137',
  [DayType.Uz]: '#FDA137',
  [DayType.Uo]: '#FDA137',

  [DayType.Sw]: '#D9D9D9',
  [DayType.Pw]: '#D9D9D9',
  [DayType.NoContract]: '#D9D9D9',
}

export const DAY_TYPE_COLORS: Record<number, string> = {
  [DayType.NONE]: '#E7ECF0',

  [DayType.P]: '#BEFADA',
  [DayType.Ps]: '#BEFADA',

  [DayType.D]: '#E7FDF1',
  [DayType.Prz]: '#E7FDF1',

  [DayType.Nn]: '#FABEDD',
  [DayType.Np]: '#FABEDD',
  [DayType.Nu]: '#FABEDD',

  [DayType.W]: '#BEEFFA',
  [DayType.Wo]: '#BEEFFA',
  [DayType.Pw]: '#BEEFFA',

  [DayType.Xw]: '#E7F8FD',
  [DayType.Xb]: '#E7F8FD',
  [DayType.Xd]: '#E7F8FD',
  [DayType.Wn]: '#E7F8FD',
  [DayType.Wx]: '#E7F8FD',
  [DayType.Ws]: '#E7F8FD',

  [DayType.Ui]: '#FFCFAC',
  [DayType.Un]: '#FFCFAC',
  [DayType.Ur]: '#FFCFAC',
  [DayType.Ux]: '#FFCFAC',
  [DayType.Us]: '#FFCFAC',
  [DayType.Um]: '#FFCFAC',
  [DayType.Uf]: '#FFCFAC',
  [DayType.Bp]: '#FFCFAC',
  [DayType.D1]: '#FFCFAC',
  [DayType.D2]: '#FFCFAC',
  [DayType.U2]: '#FFCFAC',
  [DayType.C]: '#FFCFAC',
  [DayType.M]: '#FFCFAC',
  [DayType.Uoj]: '#FFCFAC',
  [DayType.Z]: '#FFCFAC',
  [DayType.Zb]: '#FFCFAC',
  [DayType.Zs]: '#FFCFAC',
  [DayType.Zw]: '#FFCFAC',
  [DayType.Zn]: '#FFCFAC',
  [DayType.Od]: '#FFCFAC',
  [DayType.Os]: '#FFCFAC',
  [DayType.Or]: '#FFCFAC',
  [DayType.Oo]: '#FFCFAC',
  [DayType.Cn]: '#FFCFAC',
  [DayType.Cb]: '#FFCFAC',
  [DayType.Rb]: '#FFCFAC',
  [DayType.Rc]: '#FFCFAC',
  [DayType.Rw]: '#FFCFAC',
  [DayType.Bw]: '#FFCFAC',

  [DayType.U]: '#F9E4CC',
  [DayType.Uz]: '#F9E4CC',
  [DayType.Uo]: '#F9E4CC',

  [DayType.Sw]: '#F2F2F2',

  [DayType.NoContract]: '#c8c8c850',

  [DayType.WoC]: '#FFCFAC',
  [DayType.WoCn]: '#FFCFAC',
  [DayType.WoCb]: '#FFCFAC',
  [DayType.WoZ]: '#FFCFAC',
  [DayType.WoZb]: '#FFCFAC',
  [DayType.WoZs]: '#FFCFAC',
  [DayType.WoZw]: '#FFCFAC',
  [DayType.WoZn]: '#FFCFAC',
  [DayType.WoOd]: '#FFCFAC',
  [DayType.WoOr]: '#FFCFAC',
  [DayType.WoRc]: '#FFCFAC',
  [DayType.WoRw]: '#FFCFAC',
  [DayType.WoRb]: '#FFCFAC',
  [DayType.WoOo]: '#FFCFAC',
  [DayType.WoM]: '#FFCFAC',
  [DayType.WoUoj]: '#FFCFAC',
  [DayType.WoOs]: '#FFCFAC',
}
